// components/SuscripcionActivaRoute.jsx
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useLanguage } from '../hooks/useLanguage'

export default function SuscripcionActivaRoute({ children }) {
  const { ready, isPremium } = useAuth()
  const { t } = useLanguage()
  const navigate = useNavigate()

  if (!ready) return null

  if (!isPremium) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 16,
        background: 'var(--color-bg)', padding: 24, textAlign: 'center'
      }}>
        <div style={{ fontSize: 40 }}>🧾🔒</div>
        <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--color-text)' }}>
          {t('declaracion_requiere_suscripcion_titulo')}
        </div>
        <div style={{ fontSize: 13, color: 'var(--color-muted)', maxWidth: 320, lineHeight: 1.6 }}>
          {t('declaracion_requiere_suscripcion_desc')}
        </div>
        <button
          onClick={() => navigate('/suscripcion')}
          style={{ padding: '12px 20px', borderRadius: 14, border: 'none',
            background: 'linear-gradient(135deg,#16a34a,#22c55e)', color: '#fff',
            fontWeight: 700, cursor: 'pointer' }}
        >
          {t('paywall_btn')}
        </button>
      </div>
    )
  }

  return children
}